var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99646 2.19104C6.11043 1.52379 7.38452 1.17118 8.68304 1.17078C9.76341 1.17014 10.83 1.41336 11.8033 1.88231C12.7766 2.35127 13.6315 3.03385 14.3042 3.87919C14.977 4.72453 15.4503 5.71081 15.6888 6.76453C15.9273 7.81824 15.9249 8.9122 15.6818 9.96486C15.4387 11.0175 14.9611 12.0017 14.2847 12.8441C13.6082 13.6865 12.7504 14.3654 11.775 14.8301C10.7997 15.2948 9.73209 15.5333 8.65173 15.528C7.75003 15.5235 6.85888 15.3492 6.02444 15.0159L2.10076 15.6693C1.66237 15.7423 1.30402 15.3222 1.44521 14.9008L2.44895 11.9049C1.88984 10.9242 1.5687 9.8233 1.51475 8.69109C1.45295 7.39404 1.74412 6.10452 2.35725 4.95987C2.97037 3.81521 3.88249 2.8583 4.99646 2.19104Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 1.76786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92188 6.73206H11.6674",
    stroke: "white",
    strokeWidth: 1.76786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92188 10.2677H10.2679",
    stroke: "white",
    strokeWidth: 1.76786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.621427b830f33f7a7699491bbf9bad1b.svg";
export { ForwardRef as ReactComponent };